import { createSlice } from '@reduxjs/toolkit'
import { ClubPlansList } from './thunk'

export const initialState = {
    Plans: [],
    loading: true
}
const SetupFee = createSlice({
    name: 'clubPlanes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Listing
        builder.addCase(ClubPlansList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(ClubPlansList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.Plans = data
            state.loading = false
        })
        builder.addCase(ClubPlansList.rejected, (state) => {
            state.loading = false
        })
    }
})

// export const {} = SetupFee.actions
export default SetupFee.reducer
